import { useEffect, useState, useRef } from "react";
import {
  getCombos,
  getProyectoActividad,
  setPlantillaSencilla,
  setProyectoActividad,
  updateProyectoActividad,
} from "../componentes/api.js";
import SubirArchivos from "./SubirArchivos.jsx";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import { FaFileMedical } from "react-icons/fa";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import {
  Alert,
  Chip,
  Checkbox,
  Divider,
  FormGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import BarraBotones from "../comun/BarraBotones.jsx";
import Table from "react-bootstrap/Table";
import { sql } from "../componentes/api.js";
import VerAdjuntos from "./VerAdjuntos.jsx";

const Actividades = (props) => {
  /**Para cargar los datos de los combos */
  const [actividades, setActividades] = useState([]);
  const [actividadesProyecto, setActividadesProyecto] = useState([]);
  const [anexos, setAnexos] = useState([]);
  const [verAnexos, setVerAnexos] = useState(false);
  const [archivoAnexo, setArchivoAnexo] = useState("");
  const [tipoAnexo, setTipoAnexo] = useState("");
  const [cargos, setCargos] = useState([]);
  const [btnActivo, setBtnActivo] = useState(true);
  const [cant, setCant] = useState(0);
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();

  const [datos, setDatos] = useState({
    id: "",
    idProyecto: props.IdProyecto,
    idActividad: "",
    fichaCaracterizacion: false,
    idCargo: "0",
    tipoParticipante: "2",
    actividadesMensuales: "1",
    fechaIni: "",
    fechaFin: "",
    tieneAnexos: false,
    anexosRequeridosMes: 0,
    anexosRequeridosTotal: 0,
    activo: true,
    idUsuario: props.IdUsuario,
  });

  /** Para el manejo de la ventana para subir archivos **/
  const [verVentanaSubir, setVerVentanaSubir] = useState(false);

  /** Para el manejo de la ventana de creación de tipos de proyectos**/
  const [mostrarCrear, setMostrarCrear] = useState(false);

  /** Para el manejo de la ventana de Modificación de Caracterizacion**/
  const [mostrarCaracterizacionModificar, setMostrarCaracterizacionModificar] =
    useState(false);

  /*** Para la ventana de anexos */
  const [tituloAnexo, setTituloAnexo] = useState();

  useEffect(() => {
    setDatos({ ...datos, ["idProyecto"]: props.IdProyecto });
    cargarCombos({ Tabla: "actividades", Campo: "" }, "idActividad");
    cargarCombos({ Tabla: "cargos", Campo: "" }, "idCargo");
    if (props.IdProyecto !== "") {
      cargarProyectoActividad("2", "");
    }
  }, [props.IdProyecto]);

  const anexar = (event, tipo) => {
    event.preventDefault();
    setTituloAnexo(tipo);
    setVerVentanaSubir(true);
  };

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "idCargo") {
      setDatos({ ...datos, [event.target.name]: event.target.value });
      cargarProyectoActividad("", event.target.value);
    } else if (event.target.name === "fichaCaracterizacion") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
      cargarProyectoActividad("2", "");
    } else if (event.target.name === "tieneAnexos") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else if (event.target.name === "activo") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else if (event.target.name === "tipoParticipante") {
      setDatos({ ...datos, [event.target.name]: event.target.value });
      cargarProyectoActividad(event.target.value, "");
    } else if (event.target.name === "fechaIni") {
      setDatos({
        ...datos,
        [event.target.name]: event.target.value,
        anexosRequeridosTotal: calcularTotal(datos.anexosRequeridosMes),
      });
    } else if (event.target.name === "fechaFin") {
      setDatos({
        ...datos,
        [event.target.name]: event.target.value,
        anexosRequeridosTotal: calcularTotal(datos.anexosRequeridosMes),
      });
    } else if (event.target.name === "anexosRequeridosMes") {
      setDatos({
        ...datos,
        [event.target.name]: event.target.value,
        anexosRequeridosTotal: calcularTotal(event.target.value),
      });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
    }
  };

  const botones = (btn) => {
    if (btn === 0) {
      nuevo();
    } else if (btn === 1) {
      validarDatos();
    } else if (btn === 3) {
      exportar();
    } else if (btn === 4) {
      nuevo();
    }
  };

  const calcularTotal = (anexosRequeridosMes) => {
    var fechaI = new Date(datos.fechaIni);
    var fechaF = new Date(datos.fechaFin);
    var diferencia = fechaF - fechaI;
    var meses = diferencia / 1000 / 60 / 60 / 24 / 30;
    var total = Math.round(meses) * parseInt(anexosRequeridosMes);
    if (total < 1) total = 1;
    return Math.round(total);
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      const response = await getCombos(datos);
      if (cbo === "idActividad") {
        setActividades(response.data);
      } else if (cbo === "idCargo") {
        setCargos(response.data);
      }
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarProyectoActividad = async (tipO, cargO) => {
    let tipo = datos.tipoParticipante,
      cargo = datos.idCargo;
    if (tipO !== "") tipo = tipO;
    if (cargO !== "") cargo = cargO;
    try {
      if (props.IdProyecto !== "") {
        const response = await getProyectoActividad({
          idProyecto: props.IdProyecto,
          tipoParticipante: tipo,
          filtro: 0,
          idCargo: cargo,
        });
        setActividadesProyecto(response.data);
        setCant(response.data.length);
      }
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const cerrarVentanaCrear = () => {
    setMostrarCrear(false);
  };

  const consultarAnexos = async (actividad) => {
    const reg = await sql("getAnexosActividad", "POST", {
      Proyecto: props.IdProyecto,
      Actividad:
        actividad !== undefined && actividad !== null
          ? actividad
          : datos.idActividad,
    });
    setAnexos(reg);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const getIconoTipoArchivo = (tipo) => {
    if (tipo === 1) {
      return <FilePresentIcon />;
    } else if (tipo === 2) {
      return <CameraAltIcon />;
    } else if (tipo === 3) {
      return <SmartDisplayIcon />;
    } else if (tipo === 4) {
      return <VolumeUpIcon />;
    }
  };

  const grabarCampo = async (nbre) => {
    try {
      let plantilla = {
        tabla: "actividades",
        nbre: nbre,
        activo: "1",
        idUsuario: props.IdUsuario,
      };
      const response = await setPlantillaSencilla(plantilla);
      setDatos({ ...datos, idActividad: response.data.Id });
      cargarCombos({ Tabla: "actividades", Campo: "" }, "idActividad");
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Tipo de Proyecto",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      const result = await setProyectoActividad(datos);
      setDatos({ ...datos, id: result.data.Id });
      consultarAnexos(datos.idActividad);
      cargarProyectoActividad("", "");
      setBtnActivo(false);
      props.mostrarMsg(["Actividad Grabada"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const imprimir = () => {
    props.mostrarMsg(["OK, Imprime los datos"]);
  };

  const modificarRegistro = async () => {
    try {
      await updateProyectoActividad(datos);
      cargarProyectoActividad("", "");
      setBtnActivo(false);
      props.mostrarMsg(["Actividad Modificada"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const mostrarVentanaCrear = (event) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const mostrarRegistro = async (reg) => {
    setDatos({
      ...datos,
      id: reg.Id,
      idProyecto: props.IdProyecto,
      idActividad: reg.IdActividad,
      idCargo: reg.Cargo || "0",
      cantidadMes: reg.CantidadMes,
      fechaIni: reg.FechaIni.toString().substring(0, 10),
      fechaFin: reg.FechaFin.toString().substring(0, 10),
      activo: reg.Activo === "Activo" ? true : false,
      requiereAnexo: reg.RequiereAnexo === 1 ? true : false,
      cantidadAnexo: reg.CantidadAnexo,
      idUsuario: props.IdUsuario,
    });
    consultarAnexos(reg.IdActividad);
    setBtnActivo(false);
    scrollToElement();
  };

  const nuevo = () => {
    setDatos({
      id: "",
      idProyecto: props.IdProyecto,
      idActividad: "",
      idCargo: "0",
      tipoParticipante: "2",
      actividadesMensuales: "1",
      fechaIni: "",
      fechaFin: "",
      tieneAnexos: false,
      anexosRequeridosMes: 0,
      anexosRequeridosTotal: 0,
      activo: true,
      idUsuario: props.IdUsuario,
    });
    setBtnActivo(true);
  };

  const validarDatos = () => {
    if (props.IdProyecto === "") {
      props.mostrarMsg(["Por favor Seleccione un Proyecto!"]);
    } else if (datos.idActividad === "") {
      props.mostrarMsg(["Por favor Seleccione o Cree una nueva Actividad!"]);
    } else if (datos.idCargo === "") {
      props.mostrarMsg([
        "Por favor Seleccione el Cargo a quien se le asociará la Actividad!",
      ]);
    } else if (datos.fechaIni === "") {
      props.mostrarMsg([
        "Por favor digite una Fecha de Inicio de la Actividad!",
      ]);
    } else if (datos.fechaFin === "") {
      props.mostrarMsg([
        "Por favor digite una Fecha de Culminación de la Actividad!",
      ]);
    } else {
      {
        datos.id === "" ? grabarRegistro() : modificarRegistro(datos);
      }
    }
  };

  const verAnexo = (event, archivo, tipo) => {
    event.preventDefault();
    setArchivoAnexo(archivo);
    setTipoAnexo(tipo);
    setVerAnexos(true);
    // window.open(RUTA_IMG+'actividades'+'/'+ruta)
  };

  return (
    <div className="container-fluid mt-3" ref={testRef}>
      <div className="row mt-3">
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>

      <div className="row card">
        <Alert severity="success">
          <strong>ACTIVIDADES DEL PROYECTO</strong>
        </Alert>

        <div className="row">
          <FormControlLabel
            checked={datos.fichaCaracterizacion}
            name="fichaCaracterizacion"
            control={<Checkbox />}
            label="Diligenciar Ficha de Caracterización"
            onChange={asignarDato}
          />
        </div>

        <div className="row">
          <div className="col-sm-6">
            <FormControl>
              <FormLabel id="demo-form-control-label-placement">
                Seleccione el tipo de Integrante
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="tipoParticipante"
                value={datos.tipoParticipante}
              >
                <FormControlLabel
                  value="3"
                  control={<Radio />}
                  label="Participante (Beneficiario)"
                  onChange={(event) => asignarDato(event)}
                />

                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Equipo Asesor"
                  onChange={(event) => asignarDato(event)}
                />
              </RadioGroup>
            </FormControl>
          </div>

          {datos.tipoParticipante !== "3" && (
            <div className="col-sm-6">
              <div className="row form-floating mb-3">
                <select
                  type="text"
                  className="form-control"
                  name="idCargo"
                  value={datos.idCargo}
                  onChange={(event) => {
                    asignarDato(event);
                  }}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Cargo...
                  </option>
                  {cargos.map((reg) => {
                    return (
                      <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                        {" "}
                        {reg.Nbre}{" "}
                      </option>
                    );
                  })}
                </select>
                <label htmlFor="idCargo">Cargo</label>
              </div>
            </div>
          )}
        </div>

        <div className="row mt-3 mb-3 m-0">
          <Alert icon={false} severity="info">
            Seleccione una Actividad existente o cree una nueva
          </Alert>
          <div className="input-group form-floating mt-3">
            <select
              name="idActividad"
              id="idActividad"
              className="form-select form-control"
              aria-label="actividad"
              value={datos.idActividad}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Por favor seleccione una Actividad...
              </option>
              {actividades.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
            <button
              className="btn btn-primary"
              type="button"
              onClick={(event) => {
                mostrarVentanaCrear(event);
              }}
            >
              <FaFileMedical />
            </button>
          </div>
        </div>

        <div className="row mt-3 mb-3 m-0">
          <Alert icon={false} severity="info">
            Periodo de ejecución de la Actividad y cantidades a presentar
            mesualmente
          </Alert>

          <div className="col-sm-4">
            <TextField
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: "10px" }}
              name="fechaIni"
              label="Fecha Inicial"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              onBlur={(event) => asignarDato(event)}
              type="date"
              value={datos.fechaIni}
            />
          </div>
          <div className="col-sm-4">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="fechaFin"
              label="Fecha Final"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              onBlur={(event) => asignarDato(event)}
              type="date"
              value={datos.fechaFin}
            />
          </div>

          <div className="col-sm-4">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              id="actividadesMensuales"
              name="actividadesMensuales"
              label="# Actividades Mensuales"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              value={datos.actividadesMensuales}
            />
          </div>
        </div>

        <div className="row mt-3 mb-3 m-0">
          <Alert icon={false} severity="info">
            Cantidad de anexos que debe registrar
          </Alert>
          <div className="col-sm-6">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="anexosRequeridosMes"
              label="# Anexos Requeridos al Mes"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              value={datos.anexosRequeridosMes}
            />
          </div>

          <div className="col-sm-6">
            <TextField
              disabled
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="anexosRequeridosTotal"
              label="# Anexos Requeridos en Total"
              className="form-control"
              type="text"
              value={datos.anexosRequeridosTotal}
              onChange={asignarDato}
            />
          </div>
        </div>

        <div className="row mt-3 m-0">
          <Alert icon={false} severity="info">
            Si tiene anexos que el Participante debe consultar, por favor
            seleccione la siguiente opción
          </Alert>

          <FormControlLabel
            checked={datos.tieneAnexos}
            name="tieneAnexos"
            control={<Checkbox />}
            label="Tiene Anexos de guías"
            onChange={asignarDato}
          />
        </div>

        <div className="row mt-3">
          <FormGroup>
            <FormControlLabel
              name="activo"
              control={
                <Switch
                  checked={datos.activo}
                  onChange={asignarDato}
                  inputProps={{ "aria-label": "Activo" }}
                />
              }
              label={
                datos.activo === true
                  ? "Estado: Actividad ACTIVA"
                  : "Estado: Actividad ANULADA"
              }
              labelPlacement="start"
            />
          </FormGroup>
        </div>
      </div>

      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>
      <Divider component="ul" />

      <div className="row card">
        <Alert severity="info">
          ANEXOS - Una vez grabada la Actividad, seleccione los anexos guías
          para los Participantes
        </Alert>

        <div className="row mt-3 mb-3">
          <Stack direction="row" spacing={1}>
            <Chip
              icon={<SmartDisplayIcon />}
              label="Video"
              color="primary"
              disabled={btnActivo}
              onClick={(event) => anexar(event, "Video")}
            />
            <Chip
              icon={<CameraAltIcon />}
              label="Imagen"
              variant="outlined"
              disabled={btnActivo}
              onClick={(event) => anexar(event, "Imagenes")}
            />
            <Chip
              icon={<FilePresentIcon />}
              label="Documentos"
              color="primary"
              disabled={btnActivo}
              onClick={(event) => anexar(event, "Documentos")}
            />
            <Chip
              icon={<VolumeUpIcon />}
              label="Audio"
              variant="outlined"
              disabled={btnActivo}
              onClick={(event) => anexar(event, "Audio")}
            />
          </Stack>
        </div>

        <div className="row mt-1 mb-1">
          <Alert severity="info" className="mb-2">
            Los siguientes son los anexos guías para esta actividad:
          </Alert>
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            sx={{ flexWrap: "wrap" }}
          >
            {anexos.map((reg, index) => {
              return (
                <Chip
                  key={index}
                  icon={getIconoTipoArchivo(reg.TipoArchivo)}
                  label={reg.Ruta}
                  color="secondary"
                  onClick={(event) =>
                    verAnexo(event, reg.Ruta, reg.TipoArchivo)
                  }
                />
              );
            })}
          </Stack>
          <div className="form-text"></div>
        </div>
      </div>

      <div className="row card mt-2">
        <Alert severity="success">
          Las siguientes Actividades o Tareas pertenecen al Proyecto - Cantidad:{" "}
          {cant}{" "}
        </Alert>

        <Table className="table table-hover table-bordered mt-3" responsive>
          <thead className="table-primary">
            <tr>
              <th scope="col">Item #</th>
              <th scope="col">Acción</th>
              <th scope="col">Nombre Actividad</th>
              <th scope="col">Actividades Mensuales #</th>
              <th scope="col">Fecha Inicial</th>
              <th scope="col">Fecha Final</th>
              <th scope="col">Tiene Anexos</th>
              <th scope="col">Anexos Requeridos Mes</th>
              <th scope="col">Anexos Requeridos Total</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            {actividadesProyecto.map((reg, i) => {
              return (
                <tr
                  className={reg.Activo === "Inactivo" ? "table-danger" : ""}
                  key={i}
                >
                  <th> {i + 1} </th>
                  <th>
                    <a>
                      <button
                        className="btn btn-primary form-control"
                        onClick={(event) => {
                          mostrarRegistro(reg);
                        }}
                      >
                        Editar
                      </button>
                    </a>
                  </th>
                  <th> {reg.Nbre} </th>
                  <th> {reg.ActividadesMensuales} </th>
                  <th> {reg.FechaIni.toString().substring(0, 10)} </th>
                  <th> {reg.FechaFin.toString().substring(0, 10)} </th>
                  <th> {reg.TieneAnexos === 1 ? "Si" : "No"} </th>
                  <th> {reg.AnexosRequeridosMes} </th>
                  <th> {reg.AnexosRequeridosTotal} </th>
                  <th> {reg.Activo} </th>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {verVentanaSubir === true && (
        <SubirArchivos
          verVentanaSubir={verVentanaSubir}
          setVerVentanaSubir={setVerVentanaSubir}
          idProyectoActividad={datos.id}
          tituloAnexo={tituloAnexo}
          idUsuario={props.IdUsuario}
          Ruta={"proyectos/actividades"}
          Tabla={"proyecto_actividad_anexos"}
          Campo={"Ruta"}
          UsuarioReg={props.IdUsuario}
          Id={props.IdProyecto}
          mostrarMsg={props.mostrarMsg}
          consultarAnexos={consultarAnexos}
        />
      )}

      {mostrarCrear === true && (
        <VentanaCrear
          titulo={"ACTIVIDAD"}
          grabarCampo={grabarCampo}
          mostrarCrear={mostrarCrear}
          setMostrarCrear={setMostrarCrear}
          cerrarVentanaCrear={cerrarVentanaCrear}
        />
      )}

      {verAnexos === true && (
        <VerAdjuntos
          setVerAnexos={setVerAnexos}
          ruta={"proyectos/actividades/"}
          archivo={archivoAnexo}
          tipoAnexo={tipoAnexo}
        />
      )}
    </div>
  );
};

export default Actividades;
